export const ReportItems = [
  {
    label: 'Component',
    id: 'component',
  },
  {
    label: 'PL',
    id: 'pl',
  },
  {
    label: 'Trend',
    id: 'trend',
  },
  {
    label: 'WW WBR',
    id: 'wbr'
  },
  {
    label: 'HCP-Spot',
    id: 'hcp-spot'
  },
  {
    label: '13 Month Report',
    id: '13-month-report'
  },
  {
    label: 'Benchmark',
    id: 'benchmark'
  },
  {
    label: 'ASIN Metrics',
    id: 'asin-metrics'
  },
  {
    label: 'Bridging Report',
    id: 'bridging-factors'
  }
];

export const RollupItems = [
  {
    label: 'Worldwide',
    id: 'worldwide',
  },
  {
    label: 'Region',
    id: 'region',
  },
  {
    label: 'Marketplace',
    id: 'marketplace',
  },
];

export const RegionItems = [
  {
    label: 'NA',
    id: 'na',
  },
  {
    label: 'EU',
    id: 'eu',
  },
  {
    label: 'AP',
    id: 'fe',
  },
  {
    label: 'SA',
    id: 'sa',
  },
  {
    label: 'IN',
    id: 'in',
  },
];

export const MarketplaceItems = [
  {
    label: 'US',
    id: '1',
    value: 'US',
  },
  {
    label: 'MX',
    id: '771770',
    value: 'MX',
  },
  {
    label: 'CA',
    id: '7',
    value: 'CA',
  },
  {
    label: 'UK',
    id: '3',
    value: 'UK',
  },
  {
    label: 'DE',
    id: '4',
    value: 'DE',
  },
  {
    label: 'FR',
    id: '5',
    value: 'FR',
  },
  {
    label: 'JP',
    id: '6',
    value: 'JP',
  },
  {
    label: 'ES',
    id: '44551',
    value: 'ES',
  },
  {
    label: 'NL',
    id: '328451',
    value: 'NL',
  },
  {
    label: 'IT',
    id: '35691',
    value: 'IT',
  },
  {
    label: 'CN',
    id: '3240',
    value: 'CN',
  },
  {
    label: 'AU',
    id: '111172',
    value: 'AU',
  },
  {
    label: 'TR',
    id: '338851',
    value: 'TR',
  },
  {
    label: 'SG',
    id: '104444012',
    value: 'SG',
  },
  {
    label: 'BR',
    id: '526970',
    value: 'BR',
  },
  {
    label: 'IN',
    id: '44571',
    value: 'IN',
  },
  {
    label: 'AE',
    id: '338801',
    value: 'AE',
  },
  {
    label: 'SA',
    id: '338811',
    value: 'SA',
  },
];

export const MarketplaceIdToLabel = MarketplaceItems.reduce((map, obj) => {
  map[obj.id] = obj.label;
  return map;
}, {});

export const ChannelItems = [
  {
    label: 'All',
    id: 'ALL',
    value: 'All',
  },
  {
    label: 'Retail',
    id: 'RETAIL',
    value: 'Retail',
  },
  {
    label: 'FBA',
    id: 'FBA',
    value: 'FBA',
  },
  {
    label: 'MFN',
    id: 'MFN',
    value: 'MFN',
  },
];

export const ASINMetricChannelItems = [
  {
    label: 'Retail',
    id: 'RETAIL',
    value: 'Retail',
  },
  {
    label: 'FBA',
    id: 'FBA',
    value: 'FBA',
  },
  {
    label: 'MFN',
    id: 'MFN',
    value: 'MFN',
  },
];

export const Months = [
  {
    label: 'January',
    id: '01',
  },
  {
    label: 'February',
    id: '02',
  },
  {
    label: 'March',
    id: '03',
  },
  {
    label: 'April',
    id: '04',
  },
  {
    label: 'May',
    id: '05',
  },
  {
    label: 'June',
    id: '06',
  },
  {
    label: 'July',
    id: '07',
  },
  {
    label: 'August',
    id: '08',
  },
  {
    label: 'September',
    id: '09',
  },
  {
    label: 'October',
    id: '10',
  },
  {
    label: 'November',
    id: '11',
  },
  {
    label: 'December',
    id: '12',
  },
];

export const Years = [
  {
    label: '2017',
    id: '2017',
  },
  {
    label: '2018',
    id: '2018',
  },
  {
    label: '2019',
    id: '2019',
  },
  {
    label: '2020',
    id: '2020',
  },
];

export const TimeFrames = [
  {
    label: '2020',
    id: '2020',
  },
  {
    label: 'Q2 2020',
    id: '2020Q2',
  },
  {
    label: 'May 2020',
    id: '2020/05',
  },
  {
    label: 'Apr 2020',
    id: '2020/04',
  },
  {
    label: 'Q1 2020',
    id: '2020Q1',
  },
  {
    label: 'Mar 2020',
    id: '2020/03',
  },
  {
    label: 'Feb 2020',
    id: '2020/02',
  },
  {
    label: 'Jan 2020',
    id: '2020/01',
  },
  {
    label: '2019',
    id: '2019',
  },
  {
    label: 'Q4 2019',
    id: '2019Q4',
  },
  {
    label: 'Dec 2019',
    id: '2019/12',
  },
  {
    label: 'Nov 2019',
    id: '2019/11',
  },
  {
    label: 'Oct 2019',
    id: '2019/10',
  },
  {
    label: 'Q3 2019',
    id: '2019Q3',
  },
  {
    label: 'Sep 2019',
    id: '2019/09',
  },
  {
    label: 'Aug 2019',
    id: '2019/08',
  },
  {
    label: 'Jul 2019',
    id: '2019/07',
  },
  {
    label: 'Q2 2019',
    id: '2019Q2',
  },
  {
    label: 'Jun 2019',
    id: '2019/06',
  },
  {
    label: 'May 2019',
    id: '2019/05',
  },
  {
    label: 'Apr 2019',
    id: '2019/04',
  },
  {
    label: 'Q1 2019',
    id: '2019Q1',
  },
  {
    label: 'Mar 2019',
    id: '2019/03',
  },
  {
    label: 'Feb 2019',
    id: '2019/02',
  },
  {
    label: 'Jan 2019',
    id: '2019/01',
  },
  {
    label: '2018',
    id: '2018',
  },
  {
    label: 'Q4 2018',
    id: '2018Q4',
  },
  {
    label: 'Dec 2018',
    id: '2018/12',
  },
  {
    label: 'Nov 2018',
    id: '2018/11',
  },
  {
    label: 'Oct 2018',
    id: '2018/10',
  },
  {
    label: 'Q3 2018',
    id: '2018Q3',
  },
  {
    label: 'Sep 2018',
    id: '2018/09',
  },
  {
    label: 'Aug 2018',
    id: '2018/08',
  },
  {
    label: 'Jul 2018',
    id: '2018/07',
  },
  {
    label: 'Q2 2018',
    id: '2018Q2',
  },
  {
    label: 'Jun 2018',
    id: '2018/06',
  },
  {
    label: 'May 2018',
    id: '2018/05',
  },
  {
    label: 'Apr 2018',
    id: '2018/04',
  },
  {
    label: 'Q1 2018',
    id: '2018Q1',
  },
  {
    label: 'Mar 2018',
    id: '2018/03',
  },
  {
    label: 'Feb 2018',
    id: '2018/02',
  },
  {
    label: 'Jan 2018',
    id: '2018/01',
  },
];

export const Currency = [
  {
    label: 'USD',
    id: 'USD',
  },
  {
    label: 'EUR',
    id: 'EUR',
  },
  {
    label: 'Local MP',
    id: 'LOCAL',
  },
];

export default {
  ReportItems,
  RollupItems,
  RegionItems,
  MarketplaceItems,
  ChannelItems,
  Months,
  Years,
  TimeFrames,
  Currency,
};



// WEBPACK FOOTER //
// ./src/components/const/dropdown_elements.jsx